import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Initialize Firebase
const app = initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG));
export const db = getFirestore(app);
export const auth = getAuth(app);
